import { getTime } from 'date-fns';
import { get } from 'lodash';
import { useCallback, useEffect, useRef } from 'react';
import toast from 'react-hot-toast';
import { useDispatch, useStore } from 'react-redux';
import BookingRequestNotice from 'src/components/notice/booking-request';
import ToastMessage from 'src/components/toast/toast-message-layout';
import { notificationActions, pushNotificationsType } from 'src/config';

import { setClientActiveInteract } from 'src/store/app-slice';
const toastDefaultConfig = {
  duration: Infinity,
  position: 'bottom-right',
  style: {
    maxWidth: Math.max(window.innerWidth * 0.4, 500), // 40% màn hình hoặc 500px, cái nào nhỏ hơn
    width: 'auto' // Để tự động điều chỉnh độ rộng dựa trên nội dung
  }
};
const useNotificationDispatcher = () => {
  const store = useStore();
  const dispatch = useDispatch();
  const audioRef = useRef(null); // Quản lý phần tử audio

  useEffect(() => {
    // Khởi tạo audio element
    if (!audioRef.current) {
      audioRef.current = new Audio('/assets/sounds/booking_request.mp3');
    }
  }, []);

  const dispatchNotification = ({ pushType, ...dataPush }) => {
    console.log('Handling booking request: dispatchNotification', { pushType, ...dataPush });
    switch (pushType) {
      case pushNotificationsType.bookingRequest:
        handleBookingRequest(dataPush);
        break;

      case pushNotificationsType.notice:
        handleNotice(dataPush);
        break;

      case pushNotificationsType.refetch:
        handleRefetch(dataPush);
        break;

      case pushNotificationsType.noticeRefetch:
        handleNoticeRefetch(dataPush);
        break;

      default:
        console.warn(`Unknown notification type: ${pushType}`);
    }
  };

  const handleBookingRequest = useCallback((dataPush) => {
    const appState = store.getState();

    const { content, pushAction } = dataPush;
    const toastId = `${content.id}-${getTime(new Date())}`;

    const isNoticePopoverOpen = get(appState, 'bookingNotice.popoverOpen', false);
    let duration = toastDefaultConfig.duration;
    if (
      (pushAction === notificationActions.BOOKING_REQUEST_NEW && isNoticePopoverOpen) ||
      pushAction === notificationActions.BOOKING_REQUEST_REJECTED ||
      pushAction === notificationActions.BOOKING_REQUEST_RETRACT
    ) {
      duration = 1000;
    }
    toast(
      <ToastMessage toastId={toastId}>
        <BookingRequestNotice {...dataPush} />
      </ToastMessage>,
      {
        ...toastDefaultConfig,
        id: toastId,
        duration
        // ...(pushAction !== notificationActions.BOOKING_REQUEST_NEW && { duration: 5000 })
      }
    );

    // Phát âm thanh nếu người dùng đã tương tác

    const isActiveInteract = get(appState, 'app.clientActive.interact', false);
    if (isActiveInteract && audioRef.current) {
      audioRef.current.play().catch((err) => {
        dispatch(setClientActiveInteract(false));
        console.error('Error playing audio:', err);
      });
    }
  }, []);

  const handleNotice = (message) => {
    console.log('Handling notice:', message);
  };

  const handleRefetch = (message) => {
    console.log('Handling refetch:', message);
  };

  const handleNoticeRefetch = (message) => {
    console.log('Handling notice refetch:', message);
  };

  return dispatchNotification;
};
export default useNotificationDispatcher;
